// extracted by mini-css-extract-plugin
export default {"chat":"ChatPopup_chat__-O5y2","icon":"ChatPopup_icon__FETQw"};